import { Box, Tabs, TabsContentProps, VStack } from '@chakra-ui/react';

import { Loader } from 'shared';

import { useCoachingToolsQuery } from 'features/coachingTool';
import { PlanningBoardColumnItemsCount } from 'features/planning';

import { zIndexes } from 'shared/config/zIndexes';

import { CoachingToolItems } from './CoachingToolItems';

const PlanningBacklogCoachingTools = () => {
  const { data: coachingTools, isLoading } = useCoachingToolsQuery();

  if (isLoading) {
    return <Loader />;
  }

  return coachingTools?.length ? (
    <>
      <Box
        style={{
          position: 'sticky',
          top: '0',
          zIndex: zIndexes.planningColumnHeader,
          backgroundColor: 'var(--bgPrimary)',
        }}
      >
        <Box bg="var(--bgCompSecondaryBig)">
          <PlanningBoardColumnItemsCount
            name="HDE Module"
            count={coachingTools.length}
          />
        </Box>
      </Box>
      <VStack align="stretch" flex={1} gap={1} p={2}>
        <CoachingToolItems coachingTools={coachingTools} />
      </VStack>
    </>
  ) : null;
};

type TPlanningBacklogCoachingToolsTab = TabsContentProps;

export const PlanningBacklogCoachingToolsTab = (
  props: TPlanningBacklogCoachingToolsTab
) => (
  <Tabs.Content
    {...props}
    m={0}
    p={0}
    height="100%"
    width="100%"
    overflowY="auto"
    overflowX="hidden"
    value={1}
  >
    <PlanningBacklogCoachingTools />
  </Tabs.Content>
);
